import React, { useEffect } from 'react';

import { useStats } from '../../queries/stats';
import { useSchema } from '../../queries/schema';
import { getSchemaProperties } from '../../lib/schemaFormating';
import { GOALIE, useSorting } from '../../lib';

import StatsTable from './StatsTable';

const Stats = ({ filters, type, currentPage, perPage, setTotal, setPage, participantType, scheduleRequired, sorts, orders, disableSorting, ...props }) => {
  const { currentSortData, currentSortOrder, handleSorting } = useSorting();
  const { total, data, status } = useStats(filters, { participantType, type, currentPage, perPage, sorts, orders, querySort: currentSortData, queryOrder: currentSortOrder });
  const { data: schema, status: schemaStatus } = useSchema(data);

  useEffect(() => {
    setTotal(total);
    setPage(1);
  }, [ total, setTotal, setPage ])

  const properties = getSchemaProperties(schema, data, currentSortData);
  const showGroup = !filters.groupId && data?.some(player => player.group);
  return <StatsTable
    participantType={participantType}
    filters={filters}
    currentRows={data}
    statuses={[status, schemaStatus]}
    currentPage={currentPage}
    perPage={perPage}
    scheduleRequired={scheduleRequired}
    showGroup={showGroup}
    properties={properties}
    hidePositions={participantType === GOALIE}
    disableSorting={disableSorting}
    querySort={currentSortData}
    queryOrder={currentSortOrder}
    handleSorting={handleSorting}
    {...props}
  />
}

export default Stats;
